<template>
    <mdb-container>
        <mdb-btn @click="addSubCategory" color="indigo">{{
            $t("add_new_subcategory")
        }}</mdb-btn>
        <DataTableAG v-if="showDataTable && loadReady" ref="dataTable" :columns="columns" :getcontentpath="getsubcategoriespath"
            jsonobject="subcategories" :buttonList="['Muokkaa']" @pressed-button1="editSubCategories" width="1200px"
            height="750px" />
        <SubCategory v-if="editSubCategoryModal" :modal-show="editSubCategoryModal" :name="name"
            :description="description" :id="id" :url="url" :categoryid="categoryid"
            :subcategorytypeid="subcategorytypeid" :subcategorytypename="subcategorytypename"
            :subcategorytypes="subcategorytypes" :add-subcategory-state="addSubCategoryState"
            v-on:modal-cancelled="editSubCategoryCancelled" v-on:modal-ok="editSubCategoryOk" />
    </mdb-container>
</template>

<script>
import SubCategory from "@/components/EditSubCategory.vue";
import DataTableAG from "@/components/DataTableAG.vue";
import { mdbBtn, mdbContainer } from "mdbvue";
export default {
    name: "SubCategories",
    components: {
        mdbBtn,
        mdbContainer,
        SubCategory,
        DataTableAG,
    },
    methods: {
        fetchSubCategoryTypes() {
            // Haetaan alakategoriat API:sta
            this.$http.get(this.getsubcategorytypespath)
                .then((response) => {
                    this.subcategorytypes = response.data.subcategorytypes;
                    this.loadingReady();
                })
                .catch((error) => {
                    console.error("Error fetching subcategories:", error);
                });
        },
        loadingReady() {
            this.loadReady = true;
        },
        editSubCategoryCancelled() {
            this.editSubCategoryModal = false;
        },
        editSubCategoryOk() {
            this.editSubCategoryModal = false;
            this.componentKey += 1;
            this.showDataTable = false;
            this.$nextTick(() => {
                this.showDataTable = true;
            });

        },
        editSubCategories(rowData) {
            this.id = rowData.id;
            this.name = rowData.name;
            this.description = rowData.description;
            this.url = rowData.url;
            this.categoryid = rowData.categoryid;
            this.subcategorytypeid = rowData.subcategorytypeid;
            this.subcategorytypename = rowData.subcategorytypename;
            this.addSubCategoryState = false;
            this.editSubCategoryModal = true;
        },
        addSubCategory() {
            this.addSubCategoryState = true;
            this.editSubCategoryModal = true;
        },
    },
    data: () => ({
        loadReady: false,
        showDataTable: true,
        editSubCategoryModal: false,
        addSubCategoryState: false,
        componentKey: 0,
        id: 0,
        name: "",
        description: "",
        getsubcategoriespath: "/1.0/front/subcategories",
        getsubcategorytypespath: "/1.0/front/subcategorytypes",
        subcategorytypes: [],
        rows: [],
        columns: [
            {
                field: "id",
                headerName: "Id",
                width: 100,
                pinned: "left",
                sortable: true,
                filter: true,
                resizable: true,
            },
            {
                field: "name",
                headerName: "Nimi",
                width: 140,
                pinned: "left",
                sortable: true,
                filter: true,
                resizable: true,
            },
            {
                field: "subcategorytypename",
                headerName: "Alakategorian tyyppi",
                width: 200,
                pinned: "left",
                sortable: true,
                filter: true,
                resizable: true,
            },
            {
                field: "description",
                headerName: "Kuvaus",
                width: 300,
                pinned: "left",
                sortable: true,
                filter: true,
                resizable: true,
            },
            {
                field: "url",
                headerName: "Kuva URL",
                width: 200,
                pinned: "left",
                sortable: true,
                filter: true,
                resizable: true,
            },
        ],
    }),
    mounted() {
        this.fetchSubCategoryTypes()
    },
};
</script>